export class PickingListReTransportParams {
    page = 1;
    limit = 10;
    search?: undefined;
    status?: number;
    fromDate?: number;
    toDate?: number;
    employeeRowGuid?: string;
    customerRowGuid?: string;
}
